export default __webpack_public_path__ + "static/figure-rectangle-reference-bfb05956122dafde46c862b8c6c6bda8.jpg";